<template lang="pug">
modal(
    :modalName='modalName',
    modalNameShort="cert",
    :hasHeader="true",
    :hasFooter="true"
    :modalPrintContent="printContent"
    :onClose="close"
    :onShow="getData"
)
    template(slot="title")
        i.uk-icon-book
        | {{modalTitle}}
    #certificates-modal--loading(v-show="loading")
        i.uk-icon-spinner.uk-icon-spin
        | Загрузка
    #certificates-modal--data(v-if="certificates && !loading" ref="print")
        span.header Является заявителем следующих {{cert_type=="cert" ? 'сертификатов' : cert_type=="decl" ? 'деклараций' : 'сертификатов и деклараций'}}:
        template(v-for="(item, item_num) in certificates")
            .cert-block
                p.cert_title
                    span.reg_number {{item.reg_number}}
                    span.status_title(:style="`color: ${statusColors(item.status)}`") {{item.status}}
                p.status_type <b>{{item.type_name}}</b>
                p.product_name(v-if="item.product_name")
                    | <b>Продукт (изделие):</b> {{item.product_name}}
                p.srok(v-if="item.date_start")
                    | <b>Срок:</b> с {{date_format(item.date_start)}} {{item.date_end ? `по ${date_format(item.date_end)}` : ''}}
                p.annulled(v-if="item.annulled_type || item.annulled_date || item.annulled_type_termination || item.annulled_osnovanie")
                    | {{item.annulled_type ? item.annulled_type : ''}}
                    |  {{item.annulled_date ? date_format(item.annulled_date) : ''}}
                    |  {{item.annulled_type_termination ? `- ${item.annulled_type_termination}` : ''}}
                    |  {{item.annulled_osnovanie ? `(${item.annulled_osnovanie.toLowerCase()})` : ''}}
                p.manufacturer
                    | <b>{{item.manufacturer_type ? capitalize(item.manufacturer_type) : 'Изготовитель'}}:</b>
                    |  {{item.manufacturer_name ? item.manufacturer_name : ''}}
                p.applicant(v-if="item.applicant_vid")
                    | <b>Вид заявителя:</b> {{item.applicant_vid}}
            hr(v-if="item_num < certificates.length")
    #certificates-modal-pagination(slot="footer")
        old-pagination(v-if="rowsCount > 100" :paginationObj="paginationObj" :getNewContent="changePage")
</template>

<script>
import modal from "./Modal.vue"
import oldPagination from '@/components/ui/oldPagination/oldPagination.vue'
import { date_format, capitalize } from '@/helpers.ts'

export default {
    components: {
        modal,
        oldPagination,
    },
    computed: {
        auth() { return this.$store.state.auth; },
        company() { return this.$store.state.card.company; },
        certificates() { return this.$store.state.card.certificates.modal.data; },
        cert_type() { return this.$store.state.card.certificates.modal.type; },
        cert_status() { return this.$store.state.card.certificates.modal.status; },
        paginationObj() { return this.$store.state.card?.certificates?.modal?.pagination },
        rowsCount() { return this.paginationObj?.rows_count }
    },
    data() {
        return {
            modalName: "certificates",
            modalTitle: "Сертификаты и декларации",
            itemsOnPage: 100,
            loading: true,
            printContent: {
                style_name: 'certificates_modal',
                style_folder: 'certificates',
                title: "Сертификаты и декларации",
                filename: 'Certificates-' + window.company.ogrn + '.pdf',
                html: null,
                // printAll: this.test
            },
        };
    },
    updated() { if (this.$refs.print) this.printContent.html = this.$refs.print.innerHTML },
    methods: {
        close() { this.$store.dispatch('card/certificates/closeModal') },
        getData(e) {
            this.loading = true
            this.$store.dispatch("card/certificates/getInfo", {
                type: this.cert_type,
                status: this.cert_status,
                offset: 0,
                limit: 100
            }).finally(() => {
                this.loading = false
            })
        },
        changePage(limit = 100, offset = 0) {
            this.loading = true
            this.$store.dispatch("card/certificates/getInfo", {
                type: this.cert_type,
                status: this.cert_status,
                offset,
                limit
            }).finally(() => {
                this.loading = false
            })
        },
        statusColors(status) {
            switch(status) {
                case 'Действует':
                    return '#2ecc71'
                case 'Прекращен':
                    return '#e74c3c'
                case 'Архивный':
                    return '#ababab'
                default:
                    return '#e7843c'
            }
        }
        // test() {console.log("Test");}
    }
}
</script>

<style lang="scss">
#certificates-modal {
    #certificates-modal--loading {
        font-size: 14px;
        text-align: center;
        i { display: block; font-size: 24px; }
    }
    #certificates-modal--data {
        .header {
            display: block;
            font-size: 22px;
            color: rgb(11, 13, 21);
            font-weight: 600;
            margin: 10px 0px 20px 15px;
        }
        .cert-block {
            padding-left: 30px;
            * { font-size: 14px; }
            .cert_title {
                margin-bottom: 8px;
                .reg_number {
                    font-size: 1.3em;
                    vertical-align: bottom;
                    color: #1e8bc3;
                }
                .status_title  {
                    margin-left: 15px;
                }
                & ~ p {
                    margin: 8px 0;
                }
            }
        }
    }
}
</style>
